import { render } from "./RiLnbBlock.vue?vue&type=template&id=e87940cc"
import script from "./RiLnbBlock.vue?vue&type=script&lang=js"
export * from "./RiLnbBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiLnbBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e87940cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e87940cc', __exports__)) {
    api.reload('e87940cc', __exports__)
  }
  
  module.hot.accept("./RiLnbBlock.vue?vue&type=template&id=e87940cc", () => {
    api.rerender('e87940cc', render)
  })

}


export default __exports__